import { render } from "./ColorButton.vue?vue&type=template&id=58f62882&scoped=true&ts=true"
import script from "./ColorButton.vue?vue&type=script&lang=ts"
export * from "./ColorButton.vue?vue&type=script&lang=ts"

import "./ColorButton.vue?vue&type=style&index=0&id=58f62882&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f62882"]])

export default __exports__